<template>
  <div class="root-container">
    <div class="table-container">
      <!-- 顶部工具栏 -->
      <div class="search-container" style="width: 100%; margin-bottom: 20px;">
        <div class="search-row" style="display:flex; justify-content: space-between; align-items: center; width: 100%;">
          <div class="filter-left">
            <span style="font-size: 18px; font-weight: 600; color: #303133; margin-right: 20px;">{{ project.name }}看板</span>
            <el-select v-model="projectId" placeholder="请选择项目" style="width: 200px;" @change="loadBoards">
              <el-option v-for="(value, index) in projectList" :key="value.id" :label="value.name" :value="value.id" />
            </el-select>
          </div>
          <div class="button-group">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreateTask">
              新建任务
            </el-button>
            <el-button size="small" icon="el-icon-s-grid" @click="handleManageColumns">
              管理列
            </el-button>
          </div>
        </div>
      </div>

      <!-- 看板区域 -->
      <div v-loading="loading" class="board-container">
      <div class="board-columns">
        <div
          v-for="column in columns"
          :key="column.id"
          class="board-column"
        >
          <!-- 列头部 -->
          <div class="column-header" :style="{ borderTopColor: column.color || '#409EFF' }">
            <span class="column-name">{{ column.name }}</span>
            <el-tag size="mini" type="info">{{ column.tasks ? column.tasks.length : 0 }}</el-tag>
            <el-dropdown trigger="click" class="column-menu">
              <span class="el-dropdown-link">
                <i class="el-icon-more" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleAddTask(column)">
                  <i class="el-icon-plus" /> 添加任务
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleEditColumn(column)">
                  <i class="el-icon-edit" /> 编辑列
                </el-dropdown-item>
                <el-dropdown-item divided @click.native="handleDeleteColumn(column)">
                  <i class="el-icon-delete" /> 删除列
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- 任务列表 -->
          <div class="column-tasks">
            <div
              v-for="task in column.tasks"
              :key="task.id"
              class="task-card"
              :class="{ 'task-high': task.priority === 2, 'task-urgent': task.priority === 3 }"
              @click="handleEditTask(task)"
            >
              <div class="task-labels" v-if="task.labels && task.labels.length">
                <span
                  v-for="label in task.labels"
                  :key="label.id"
                  class="task-label"
                  :style="{ backgroundColor: label.color }"
                >
                  {{ label.name }}
                </span>
              </div>
              <div class="task-title">{{ task.title }}</div>
              <div class="task-meta">
                <div class="task-left">
                  <el-tooltip v-if="task.due_date" :content="'截止: ' + task.due_date" placement="top">
                    <span class="task-due" :class="{ 'task-overdue': isOverdue(task.due_date) }">
                      <i class="el-icon-time" /> {{ formatDate(task.due_date) }}
                    </span>
                  </el-tooltip>
                </div>
                <div class="task-right">
                  <el-avatar v-if="task.assignee" :size="24" :src="task.assignee.avatar">
                    {{ task.assignee.nickname ? task.assignee.nickname.charAt(0) : '?' }}
                  </el-avatar>
                  <span v-else class="task-unassigned">
                    <i class="el-icon-user" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

          <!-- 添加列按钮 -->
          <div class="board-column add-column">
            <el-button type="text" icon="el-icon-plus" @click="handleAddColumn">
              添加列
            </el-button>
          </div>
        </div>
      </div>

      <!-- 任务表单弹窗 -->
    <task-form
      :visible.sync="taskDialogVisible"
      :task-id="editingTaskId"
      :column-id="selectedColumnId"
      :board-id="currentBoardId"
      :project-id="projectId"
      @success="loadBoardDetail"
    />

      <!-- 列管理弹窗 -->
      <column-dialog
        :visible.sync="columnDialogVisible"
        :columns="columns"
        :board-id="currentBoardId"
        @success="loadBoardDetail"
      />
    </div>
  </div>
</template>

<script>
import { getBoardDetail, deleteColumn, getAllProjects, createTask,createColumn } from '@/api/task'
import {getAdmins} from '@/api/system'
import TaskForm from './components/task-form'
import ColumnDialog from './components/column-dialog'

export default {
  name: 'TaskBoards',
  components: { TaskForm, ColumnDialog },
  data() {
    return {
      projectId: null,
      project: [],
      projectList: [],
      loading: false,
      currentBoardId: null,
      currentBoard: {},
      columns: [],
      adminsList: [],
      taskDialogVisible: false,
      columnDialogVisible: false,
      editingTaskId: null,
      selectedColumnId: null
    }
  },
  mounted() {
    this.projectId = this.$route.query.project_id ? parseInt(this.$route.query.project_id) : null
    this.loadProjectList()
    this.loadBoards()
    this.loadAdmins()
  },
  methods: {
    async loadProjectList() {
      try {
        const res = await getAllProjects()
        if (res.code === 200) {
          console.log('项目列表:', res.data)
          this.projectList = res.data || []
          // 改成vue2的语法
          this.projectName = res.data.find(p => p.id === this.projectId).name || ''
          console.log('项目名称:', this.projectName)
        }
      } catch (error) {
        console.error('获取项目列表失败:', error)
      }
    },
    loadAdmins(){
      getAdmins().then(res => {
        if (res.code === 200) {
          this.adminsList = res.data || []
        }
      })
    },
    async loadBoards() {
      try {
        const res = await getBoardDetail(this.projectId )
        if (res.code === 200) {
          const boardList = res.data.board 
          this.project = res.data.project
          console.log('看板列表:', boardList)
          this.columns = boardList.columns || []
          // if (boardList.length > 0) {
          //   this.currentBoardId = boardList[0].id
          //   this.loadBoardDetail()
          // }
        }
      } catch (error) {
        console.error('获取看板列表失败:', error)
      }
    },
    async loadBoardDetail() {
      if (!this.currentBoardId) return
      this.loading = true
      try {
        const res = await getBoardDetail(this.currentBoardId)
        if (res.data && res.data.code === 200) {
          this.currentBoard = res.data.data || {}
          this.columns = this.currentBoard.columns || []
        }
      } catch (error) {
        console.error('获取看板详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCreateTask() {
      this.editingTaskId = null
      this.selectedColumnId = this.columns.length > 0 ? this.columns[0].id : null
      this.taskDialogVisible = true
    },
    handleAddTask(column) {
      this.editingTaskId = null
      this.selectedColumnId = column.id
      this.taskDialogVisible = true
    },
    handleEditTask(task) {
      this.editingTaskId = task.id
      this.selectedColumnId = task.column_id
      this.taskDialogVisible = true
    },
    handleManageColumns() {
      this.columnDialogVisible = true
    },

    handleAddColumn() {
      this.$prompt('请输入列名称', '添加列', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return '列名称不能为空'
          }
          return true
        }
      }).then(async ({ value }) => {
        try {
          createColumn({
            project_id: this.projectId,
            board_id: this.currentBoardId,
            name: value.trim()
          }).then(res=>{
            if (res.data && res.data.code === 200) {
              this.$message.success('添加成功')
              this.loadBoardDetail()
            }
          })
          
        } catch (error) {
          console.error('添加列失败:', error)
          this.$message.error('添加失败')
        }
      })
    },
    handleEditColumn(column) {
      this.$prompt('请输入列名称', '编辑列', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: column.name,
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return '列名称不能为空'
          }
          return true
        }
      }).then(async ({ value }) => {
        try {
          const { updateColumn } = await import('@/api/task')
          const res = await updateColumn(column.id, {
            name: value.trim()
          })
          if (res.data && res.data.code === 200) {
            this.$message.success('更新成功')
            this.loadBoardDetail()
          }
        } catch (error) {
          console.error('更新列失败:', error)
          this.$message.error('更新失败')
        }
      })
    },
    handleDeleteColumn(column) {
      this.$confirm('确认删除该列吗？列中的任务将被一并删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteColumn(column.id)
          if (res.data && res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadBoardDetail()
          }
        } catch (error) {
          console.error('删除列失败:', error)
          this.$message.error('删除失败')
        }
      })
    },
    isOverdue(dateStr) {
      if (!dateStr) return false
      const due = new Date(dateStr)
      const now = new Date()
      return due < now
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return `${date.getMonth() + 1}/${date.getDate()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.root-container {
  height: 100%;
}
.table-container {
  height: 100%;
}
// 顶部工具栏样式
.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;

  .filter-left {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .button-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
}

.board-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;

  .board-title {
    display: flex;
    align-items: center;
    gap: 15px;

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .board-actions {
    display: flex;
    gap: 10px;
  }
}

.board-container {
  overflow-x: auto;
  height: calc(100% - 60px);
  padding-bottom: 20px;
}

.board-columns {
  display: flex;
  gap: 15px;
  min-width: fit-content;
}

.board-column {
  width: 300px;
  flex-shrink: 0;
  background: #f5f7fa;
  border-radius: 8px;
  max-height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;

  &.add-column {
    background: transparent;
    border: 2px dashed #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
  }
}

.column-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-top: 3px solid #409EFF;
  border-radius: 8px 8px 0 0;
  background: #fff;

  .column-name {
    flex: 1;
    font-weight: 600;
    font-size: 14px;
  }

  .column-menu {
    margin-left: 8px;
    cursor: pointer;
    color: #909399;

    &:hover {
      color: #409EFF;
    }
  }
}

.column-tasks {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.task-card {
  background: #fff;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &.task-high {
    border-left: 3px solid #E6A23C;
  }

  &.task-urgent {
    border-left: 3px solid #F56C6C;
  }
}

.task-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 8px;
}

.task-label {
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  color: #fff;
}

.task-title {
  font-size: 14px;
  line-height: 1.5;
  color: #303133;
  margin-bottom: 10px;
  word-break: break-word;
}

.task-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.task-due {
  font-size: 12px;
  color: #909399;

  &.task-overdue {
    color: #F56C6C;
  }
}

.task-unassigned {
  color: #c0c4cc;
  font-size: 18px;
}
</style>
